import * as React from 'react';
export const firsttechSvg = React.forwardRef(function firsttechSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#509E46',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M5.99 19.09c-1.35-1.92-1.35-1.94 0-3.86s8.38-7.35 10.41-9.27c2.03-1.92 1.6.77 1.6.77l.03 3.1-6.43 5.4h1.6c1.35 0 2.4.4 2.4 2.31v8.5c0 1.28-.93 1.41-1.6.77-.68-.64-6.99-6.27-8.01-7.72zm12.04-7.72c0-1.92 1.7-1.7 2.37-1.06.68.64 4.26 3.64 5.61 4.92 1.35 1.28 1.35 2.58 0 3.86-1.35 1.28-4.93 5.54-5.6 6.18-.68.64-2.4 1.14-2.4-.78l.02-13.12z',
      }),
    ),
  );
});
firsttechSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var firsttech = {
  category: 'brand',
  colorable: false,
  name: 'firsttech',
  svg: firsttechSvg,
};
